import React from 'react';

const Footer = () => {
    return (
        <>
            <footer className='footer fixed-bottom'>
                <div className='container' style={{textAlign:'center'}}>
                    <span className="text-muted" >Created with <span style={{color:'#FF0000', fontSize:'1.3rem'}}>{'\u2665'}</span> by Group 2</span>
                </div>
            </footer>
        </>
    );
};

export default Footer;